import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43f1dcb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "text-left font-weight-bold",
  style: {"white-space":"pre-line"}
}
const _hoisted_2 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = {
  class: "text-left",
  style: {"white-space":"pre-line"}
}
const _hoisted_5 = {
  class: "text-left",
  style: {"white-space":"pre-line"}
}
const _hoisted_6 = {
  class: "text-left",
  style: {"white-space":"pre-line"}
}

import { ref } from "vue";
import { useErrors, clearErrors } from "@/store/useErrors";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorModal',
  setup(__props) {

const showDetails = ref(false);
const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _unref(useErrors).visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(useErrors).visible) = $event)),
    persistent: "",
    "max-width": "500",
    transition: false,
    scrollable: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_alert, {
                dense: "",
                shaped: "",
                type: "error",
                transition: "scale-transition"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("api-error-api.title")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "pa-5" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(useErrors)?.messages || [], (message, i) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      density: "compact",
                      key: `Messages${i}`
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _createVNode(_component_v_icon, { class: "mr-2" }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-message-text")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(message.code) + " - " + _toDisplayString(message.description), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              (showDetails.value && _unref(useErrors)?.status)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)("api-error-api.details")), 1),
                    _createVNode(_component_v_list_item, { dense: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_v_icon, { class: "mr-2" }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-api")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(useErrors)?.url), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item, { dense: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_v_icon, { class: "mr-2" }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-code-tags")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(useErrors)?.status), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item, { dense: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_v_icon, { class: "mr-2" }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-label")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(useErrors)?.statusText), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                small: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showDetails.value = !showDetails.value))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { class: "mr-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-magnify")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(_toDisplayString(_unref(t)("button.details")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                small: "",
                onClick: _withModifiers(_unref(clearErrors), ["stop"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { class: "mr-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-close")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(_toDisplayString(_unref(t)("button.close")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})